import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GeneralFeedbackDialog, useOfferFeedbackDialog } from 'features/feedback';
import { JobApplication } from 'features/myJobs';
import { isInPast } from 'features/myJobs/utils';
import { useCallback } from 'react';

import JobListItem from './JobListItem';
import PastDivider from './PastDivider';

export interface JobListProps {
  jobs: JobApplication[];
}

function sortByDateRange(a: JobApplication, b: JobApplication, direction: 'asc' | 'desc') {
    if (direction === 'asc') {
        return new Date(a.dateStartUtc).getTime() - new Date(b.dateStartUtc).getTime();
    }

    return new Date(b.dateEndUtc).getTime() - new Date(a.dateEndUtc).getTime();
}

function toSorted<T>(arr: readonly T[], cmp?: (a: T, b: T) => number) {
    return [ ...arr ].sort(cmp);
}


export default function JobList({ jobs }: JobListProps) {
    const jobsPast = toSorted(jobs.filter(isInPast), (a, b) => sortByDateRange(a, b, 'desc'));
    const jobsActive = toSorted(jobs.filter((job) => !isInPast(job)), (a, b) => sortByDateRange(a, b, 'asc'));

    const { onOpen: openFeedbackDialog, ...feedbackDialogState } = useOfferFeedbackDialog('OfferFeedback');

    const handleFeedbackClick = useCallback((job: JobApplication) => {
        openFeedbackDialog(job.orderId, job.orderRoleId);
    }, [ openFeedbackDialog ]);

    return (
        <>
            <Root>
                { jobsActive.map((job) => (
                    <JobListItem key={ job.id }
                        job={ job }
                        onFeedbackClick={ handleFeedbackClick } />
                )) }

                { jobsActive.length > 0 && jobsPast.length > 0 && (
                    <PastDivider />
                ) }

                { jobsPast.map((job) => (
                    <JobListItem key={ job.id }
                        job={ job }
                        onFeedbackClick={ handleFeedbackClick } />
                )) }
            </Root>

            <GeneralFeedbackDialog { ...feedbackDialogState } />
        </>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    rowGap: theme.spacing(3)
}));

